export default {
  name: 'auth',
  translationKey: 'auth-module',
  routePrefix: 'auth',
  routeNamePrefix: 'auth',
}
